import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fat } from '@fortawesome/pro-thin-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import type { App } from 'vue';

export default {
  install: (app: App) => {
    library.add(fab); // BRAND icons
    library.add(fat); // THIN icons
    library.add(fas); // SOLID icons
    app.component('font-awesome-icon', FontAwesomeIcon);
  },
};
